import { IconEdit } from '@tabler/icons-react';
import React from 'react';
import { BasicButton, IBasicButtonProps } from 'src/design/atoms/BasicButton';

export type IEditButtonProps = IBasicButtonProps;

const DefaultProps: Partial<IEditButtonProps> = {
  variant: 'light',
  leftSection: <IconEdit size={16} />,
};

/** @registry Light "Edit" button with a pencil icon. */
export const EditButton = React.forwardRef<HTMLButtonElement, IEditButtonProps>(
  ({ children = 'Edit', ...props }, ref) => {
    return (
      <BasicButton {...DefaultProps} {...props} ref={ref}>
        {children}
      </BasicButton>
    );
  },
);
EditButton.displayName = 'EditButton';
